import { Mail, Send } from 'lucide-react';
import { useState } from 'react';
import { AuthInput } from './AuthInput';
import { AuthLayout } from './AuthLayout';
import { sendPasswordResetEmail } from 'firebase/auth';

export const ForgotPassword = ({ isLight, onNavigate, auth }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    setEmailSent(false);

    try {
      await sendPasswordResetEmail(auth, email);
      setEmailSent(true);
    } catch (err) {
      console.error(err);
      // For security, don't reveal if the email is registered or not.
      // After the email is sent, we show a generic success message regardless.
      // So, even on error, we can show the success state to prevent email enumeration.
      setEmailSent(true);
    } finally {
      setLoading(false);
    }
  };
  
  // Show this confirmation screen whether the email exists or not, for security.
  if (emailSent) {
    return (
      <AuthLayout
        title="Check your inbox"
        subtitle={`If a user exists with this email, a password reset link has been sent.`}
        isLight={isLight}
        modeText="Back to login?"
        modeAction="Sign in"
        onToggleMode={() => onNavigate('/login')}
      >
        <div className="text-center py-8">
            <div className="bg-cyan-500/10 w-16 h-16 rounded-lg flex items-center justify-center mx-auto mb-6">
              <Send className="text-cyan-500" size={32} />
            </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset Password"
      subtitle="Enter your email to receive a reset link"
      isLight={isLight}
      modeText="Remembered your password?"
      modeAction="Sign in"
      onToggleMode={() => onNavigate('/login')}
    >
      <form onSubmit={handleResetPassword}>
        <AuthInput label="Email Address" type="email" icon={Mail} placeholder="name@email.com" value={email} onChange={setEmail} isLight={isLight} />
        
        {error && <p className="text-red-500 text-[10px] mb-4 uppercase tracking-wider">{error}</p>}

        <button
          disabled={loading}
          type="submit"
          className={`w-full mt-4 font-black py-5 rounded uppercase text-xs tracking-[0.2em] flex items-center justify-center gap-2 transition-all ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          } ${isLight ? 'bg-slate-900 text-white hover:bg-slate-800' : 'bg-white text-black hover:bg-slate-200'}`}
        >
          {loading ? 'Sending...' : 'Send Reset Link'} <Send size={14} />
        </button>
      </form>
    </AuthLayout>
  );
};
